
<div class="card-box">
  <h4 class="title-f">Address Details</h4>
  <div class="row" style="padding: 0px 0px 23px 10px;">
    <div class="col-md-8">
      <h5 class="form-lable">Loan Number:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <button class="btn btn-primary mr-0" style="margin-top: 24px;float: right;">Copy As New</button>
    </div>
    <div class="col-md-12">
      <h5 class="form-lable">Address Type *:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
      <h5 class="form-lable">Address 1*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
      <h5 class="form-lable">Name in Arabic:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-12">
      <h5 class="form-lable">Address 2*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-12">
      <h5 class="form-lable">Address 3*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-12">
      <h5 class="form-lable">Address 4*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">State *:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">State *:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">City *:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Zip Code:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Email(E):</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Fax No:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Contact Address:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Status:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Signature:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Maker ID:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Make Date:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <!-- <div class="col-md-12 mt-20">
          <button type="button" class="btn btn-primary">Add</button>
     </div> -->

  </div>
</div>

  <!-- <div class="doc-table">
    <div class="card-box"> <p-table [value]="rows" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
                <tr style="text-align: center;">
                    <th>Loan Number</th>
                    <td colspan="2"><input type="text"> </td>
                    <th ><button>Copy As New</button></th>
                </tr>
                <tr style="text-align: center;"  >
                  <th>Address Type *</th>
                  <td colspan="3"><input type="text"> </td>
              </tr>
              <tr style="text-align: center;">
                <th>Address 1*</th>
                <td><input type="text"> </td>
                <th>Name in Arabic</th>
                <td> <input type="text"> </td>
            </tr>
            <tr style="text-align: center;">
              <th>Address 2*</th>
              <td colspan="3"> <input type="text"> </td>

          </tr>
          <tr style="text-align: center;">
            <th>Address 3*</th>
            <td colspan="3"> <input type="text"> </td>
        </tr>
        <tr style="text-align: center;">
          <th>Address 4*</th>
          <td colspan="3"> <input type="text"> </td>
      </tr>
          <tr style="text-align: center;">
            <th>State *</th>
            <td> <input type="text"> </td>
            <th>City *</th>
            <td> <input type="text"> </td>
        </tr>

        <tr style="text-align: center;">
          <th>Zip Code</th>
          <td> <input type="text"> </td>
          <th>Email(E)</th>
          <td> <input type="text"> </td>
      </tr>

      <tr style="text-align: center;">
        <th>Fax No</th>
        <td> <input type="text"> </td>
        <th></th>
        <td></td>
    </tr>

    <tr style="text-align: center;">
      <th>Contact Address</th>
      <td> <input type="checkbox"> </td>
      <th>Status</th>
      <td> <input type="checkbox"> </td>
    </tr>



        </ng-template>
     </p-table>  </div>
    </div>

    <br>
    <div class="doc-table">
    <div class="card-box"> <p-table [value]="rows" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
        <ng-template pTemplate="header">
    <tr>
      <th colspan="6">Signature</th>
    </tr>
    <tr style="text-align: center;">
      <th>Maker ID</th>
      <td colspan="2"> <input type="text"> </td>
      <th>Make Date</th>
      <td colspan="2"> <input type="text"> </td>
    </tr>


    <tr style="text-align: center;">
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Address Details</button> </td>
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Bank Details</button> </td>
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Income Details</button> </td>
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Liability Details</button> </td>
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Esisting Asset Details</button> </td>
      <td> <button class="btn btn-primary mr-0" style="width: 100%;">Credit Card Details</button> </td>
    </tr>

        </ng-template>
     </p-table>  </div>
    </div> -->





